import {
  FETCH_BUZZ,
  FETCH_BUZZ_SUCCESS,
  FETCH_BUZZ_ERROR,
  ADD_BUZZ,
  ADD_BUZZ_SUCCESS,
  ADD_BUZZ_ERROR,
  RESET_ADD_BUZZ,
  UPDATE_BUZZ,
  UPDATE_BUZZ_SUCCESS,
  UPDATE_BUZZ_ERROR,
  DELETE_BUZZ,
  DELETE_BUZZ_SUCCESS,
  DELETE_BUZZ_ERROR,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  deleting: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BUZZ: {
      return {...state, error: '', loading: true};
    }
    case ADD_BUZZ: {
      return {...state, error: '', updating: true};
    }
    case UPDATE_BUZZ: {
      return {...state, error: '', updating: true};
    }
    case DELETE_BUZZ: {
      return {...state, error: '', deleting: true};
    }
    case FETCH_BUZZ_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_BUZZ_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case UPDATE_BUZZ_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }};
    }
    case DELETE_BUZZ_SUCCESS: {
      const { id } = action.payload;
      const newData = state.data.filter(item => item.id !== id);
      return {...state, error: '', deleting: false, data: newData, payload: { code: 200, message: 'Xóa dữ liệu thành công!' }};
    }
    case FETCH_BUZZ_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_BUZZ_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case UPDATE_BUZZ_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case DELETE_BUZZ_ERROR: {
      return {...state, deleting: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_ADD_BUZZ: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
